"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkedIcon = exports.uncheckedIcon = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uncheckedIcon = exports.uncheckedIcon = _react2.default.createElement(
  "svg",
  {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: { position: "absolute", top: 0 }
  },
  _react2.default.createElement("path", {
    /* eslint-disable max-len */
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12"
    /* eslint-eable max-len */
    , fill: "#fff",
    fillRule: "evenodd"
  })
); /*
   The MIT License (MIT)
   
   Copyright (c) 2015 instructure-react
   
   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:
   
   The above copyright notice and this permission notice shall be included in all
   copies or substantial portions of the Software.
   
   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   SOFTWARE.
   */

var checkedIcon = exports.checkedIcon = _react2.default.createElement(
  "svg",
  {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: { position: "absolute", top: 0 }
  },
  _react2.default.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
  })
);


//////////////////
// WEBPACK FOOTER
// ./~/react-switch/dist/icons.js
// module id = 334
// module chunks = 0